import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from '@/store';
export default {
  data: function data() {
    return {
      // 顶部栏初始数
      visibleNumber: 5
    };
  },
  computed: {
    routes: function routes() {
      return this.$store.state.menu.addRoutes;
    },
    activeId: function activeId() {
      return this.$store.state.menu.activeId;
    }
  },
  created: function created() {
    var _this = this;
    this.setVisibleNumber();
    this.$nextTick(function () {
      var loop = setInterval(function () {
        if (_this.routes && _this.routes.length > 0) {
          clearInterval(loop);
          _this.initSubRouters();
        }
      }, 50);
    });
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.setVisibleNumber);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.setVisibleNumber);
  },
  mounted: function mounted() {},
  methods: {
    setVisibleNumber: function setVisibleNumber() {
      var width = document.body.clientWidth * 0.6;
      console.log("visibleNumber", width);
      this.visibleNumber = parseInt(width / 140);
      console.log("visibleNumber", this.visibleNumber);
    },
    handleSelect: function handleSelect(index) {
      var routes = this.routes.filter(function (item) {
        return item.id == index;
      });
      if (routes[0].status == 0) {
        this.$message({
          message: '当前菜单已停用',
          duration: 1500
        });
        return;
      }
      store.dispatch('menu/initSubRouters', routes[0]);
      store.dispatch('menu/setActiveId', index);
    },
    initSubRouters: function initSubRouters() {
      var fullPath = this.$route.path;
      console.log("fullPath", fullPath);
      console.log("fullPath", this.routes);
      var _loopMenu = function loopMenu(arr) {
        for (var i = 0; i < arr.length; i++) {
          var element = arr[i];
          if (element.path == fullPath) {
            return true;
          } else {
            if (element.children && element.children.length > 0) {
              var r = _loopMenu(element.children);
              if (r) {
                return r;
              }
            }
          }
        }
      };
      for (var i = 0; i < this.routes.length; i++) {
        if (this.routes[i].children) {
          var re = _loopMenu(this.routes[i].children);
          if (re) {
            this.handleSelect(this.routes[i].id);
            break;
          }
        }
      }
    }
  }
};